import React, {useState} from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import TextField from '@material-ui/core/TextField'; 
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

import { Link, useHistory } from 'react-router-dom'
import {dispatchLogin} from '../../redux/actions/authAction'
import {useSelector,useDispatch} from 'react-redux'
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import axios from 'axios'
import { Redirect } from "react-router-dom";

const initialState = {
  email: '',
  password: '',
  err: '',
  success: ''
}

const useStyles = makeStyles(styles);

function LoginPage() {

  

  const [user, setUser] = useState(initialState)
  const dispatch = useDispatch()
  const history = useHistory()

  const [redirctTo, setRedirctTo] = useState(false);
  const [redirctTo1, setRedirctTo1] = useState(false);
  const [tc, setTC] = React.useState(false);
  const [Errmessage, setErrmessage] = React.useState("");
  

  const {email, password, err, success} = user

  const handleChangeInput = e => {
    
    const {name, value} = e.target
    setUser({...user, [name]:value, err: '', success: ''})
  }


  const handleSubmit = async e => {
    e.preventDefault()
    try {
        const res = await axios.post('/user/login', {email, password})
        setUser({...user, err: '', success: res.data.msg})

        console.log(res);
        
        localStorage.setItem('local_login', true)
        localStorage.setItem('user_name', res.data.name)
        localStorage.setItem('user_avatar', res.data.avatar)

        setRedirctTo(true)

    } catch (err) {
      console.log(err.response.data.msg);
      setErrmessage(err.response.data.msg);
      showNotification(true);
        //err.response.data.msg && 
       // setUser({...user, err: err.response.data.msg, success: ''})
    }
}


  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  React.useEffect(() => {


    const local_login = localStorage.getItem('local_login')
    let token = "";
    if(local_login){
      
      const getToken = async () => {
        try {
        const res = await axios.post('/user/refresh_token', null)
        
        token = res.data.access_token;

        const res2 = await axios.get('/user/infor', {
          headers: {Authorization: token}
        })     

        setRedirctTo(true);
      } catch (err) {
        //setRedirctTo(true);
    }
      }
      getToken()
        
    }else{
      //setRedirctTo(true)
    }

    let id = setTimeout(function() {
      setCardAnimation("");
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });
  const classes = useStyles();

  const showNotification = place => {
    setTC(true);
    setTimeout(function() {
      setTC(false);
    }, 3000);
  };

if (redirctTo){
  console.log("enter here 2");
  return <Redirect to='/admin/dashboard'  />
}

if (redirctTo1){
  console.log("enter here 1");
  return <Redirect to='/auth/login'  />
}

  return (
    <div className={classes.container}>
       <Snackbar
        place="tc"
        color="rose"
        icon={AddAlert}
        message={Errmessage}
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
      <GridContainer justify="center">
        <GridItem xs={12} sm={6} md={4}>
          <form  onSubmit={handleSubmit}>
            <Card login className={classes[cardAnimaton]}>
              <CardHeader
                className={`${classes.cardHeader} ${classes.textCenter}`}
                color="rose"
              >
                <h4 className={classes.cardTitle}>Log in</h4>
                
              </CardHeader>
              <CardBody>
                

                <TextField fullWidth id="standard-basic" label="Email" name="email" onChange={handleChangeInput} />
                <TextField fullWidth id="standard-basic" label="Password" type="password" name="password" onChange={handleChangeInput} />

                
              </CardBody>
              <CardFooter className={classes.justifyContentCenter}>
                <Button type="submit" color="rose" simple size="lg" block>
                  Let{"'"}s Go
                </Button>
              </CardFooter>
            </Card>
          </form>
        </GridItem>
        
      </GridContainer>
    </div>
  );
}


const mapStateToProps = state => ({
  isLogged: state.auth.isLogged,
});

const wrapper = connect(mapStateToProps);
const component = wrapper(LoginPage);

export default component;